// Image assets: AI-generated portraits + curated lifestyle photography.
export const assets = {
  agents: {
    reply:
      "https://static.prod-images.emergentagent.com/jobs/9a9a624e-4fd1-49cd-b482-d9d05d1d620b/images/a37d5bfa137f75b85afa66562d54e2c607d5910f7032cf53eb86c1276faf0762.jpeg",
    share:
      "https://static.prod-images.emergentagent.com/jobs/9a9a624e-4fd1-49cd-b482-d9d05d1d620b/images/335af97be7dfc9969acf551c8af3dddae996a992d75e9c58c9113d7b31ebb85c.jpeg",
    geo:
      "https://static.prod-images.emergentagent.com/jobs/9a9a624e-4fd1-49cd-b482-d9d05d1d620b/images/ab12f049e15578edcfb4a6da94a516379578dacf5bf501148f532cc00219efa2.jpeg",
  },
  lifestyle: {
    heroOwner:
      "https://images.unsplash.com/photo-1753351052363-53ce102830eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    coffeeCounter:
      "https://images.unsplash.com/photo-1563244535-471b9fb5a0fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    coffeeOwner:
      "https://images.unsplash.com/photo-1507914464562-6ff4ac29692f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    salon:
      "https://images.unsplash.com/photo-1746723378067-83a345ff3160?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    gym:
      "https://images.unsplash.com/photo-1616279969096-54b228f5f103?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    restaurantOwner:
      "https://images.unsplash.com/photo-1682368360051-f73e87dd9106?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
};
